module.exports = __webpack_public_path__ + "static/media/lora_indoor_modbus_en.5fdda643.md";